var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2499 20.2505H3.74994",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 7.42857V15.5714C13.4995 15.9462 13.8353 16.25 14.2495 16.25H17.9995C18.4137 16.25 18.7495 15.9462 18.7495 15.5714V7.42857C18.7495 7.05381 18.4137 6.75 17.9995 6.75H14.2495C13.8353 6.75 13.4995 7.05381 13.4995 7.42857Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74951 3H5.99951C5.5853 3 5.24951 3.31222 5.24951 3.69737V15.5526C5.24951 15.9378 5.5853 16.25 5.99951 16.25H9.74951C10.1637 16.25 10.4995 15.9378 10.4995 15.5526V3.69737C10.4995 3.31222 10.1637 3 9.74951 3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.37bb4f5fdee75d8d809e28eecb358480.svg";
export { ForwardRef as ReactComponent };